import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { festivalTouchesAtom } from '../store/alerts';
import { festivalTouchOn, type FestivalTouch } from '../lib/festivalMode';

const localDateKey = (now: Date) =>
  `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;

/**
 * Today's festival touch on this device (D309–D312), or null on a plain
 * day or when Settings has festival touches off. Worked out on the device
 * from the bundled tables, once per local date; nothing is sent.
 */
export function useFestivalTouch(): FestivalTouch | null {
  const enabled = useAtomValue(festivalTouchesAtom);
  const day = localDateKey(new Date());
  return useMemo(
    () => (enabled ? festivalTouchOn(new Date()) : null),
    // Recomputed when the local date changes, on the next render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [enabled, day]
  );
}
